import { Injector, NgModule } from '@angular/core';
import { Route, RouterModule, Routes } from '@angular/router';

import { ClientConfigProductName, ProductService } from '@frontend/vanilla/core';

import { BingoBootstrapService } from './Bootstrap/bingo-bootstrap.service';
import { BINGO_INTERNAL_ROUTES } from './bingo-internal.routes';
import { provideBingoAppBootstrap } from './host-app/bingo-host-app.provider';
import { bingoProductActivateGuard, bingoProductDeactivateGuard } from './route.guard';

export const BINGO_ROUTES: Routes = [
    {
        path: '',
        resolve: [BingoBootstrapService],
        children: [...BINGO_INTERNAL_ROUTES],
    },
];

export const BINGO_HOSTAPP_ROUTES: Route[] = [
    {
        path: '',
        canMatch: [bingoProductActivateGuard],
        canDeactivate: [bingoProductDeactivateGuard],
        children: [...BINGO_INTERNAL_ROUTES],
    },
];
@NgModule({
    imports: [RouterModule.forChild(BINGO_HOSTAPP_ROUTES)],
    providers: [provideBingoAppBootstrap()],
})
export class BingoRoutesModule {
    constructor(injector: Injector) {
        injector.get(ProductService).register(ClientConfigProductName.BINGO, injector);
    }
}
